import React from 'react';
import PropTypes from 'prop-types';
import translate from 'components/hoc/translate';
import DropDownButton from 'components/button/DropDownButton';
import utils from 'helpers/utils';

const EntityShowActions = (props) => {
    const {
        actions,
        id,
        title,
        translate,
    } = props;

    return (
        <DropDownButton title={ title } >
            { actions.map((action) => {
                return React.cloneElement(action, {
                    id,
                    key: `entity-actions-${ utils.uuid() }`,
                    style: {
                        borderRadius: '0',
                    },
                    translate,
                });
            }) }
        </DropDownButton>
    );
};

EntityShowActions.defaultProps = {
    actions: [],
};

EntityShowActions.propTypes = {
    actions: PropTypes.arrayOf(PropTypes.node).isRequired,
    id: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]).isRequired,
    title: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(EntityShowActions);


// WEBPACK FOOTER //
// ./src/components/button/actions/EntityShowActions.js